import { Component, OnInit } from '@angular/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as backInter from 'app/auth/auth-data.model';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import { ReactivosService } from "app/main/wizard-cgo/services/reactivos.service";
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'preview-encuestas',
  templateUrl: './preview-encuestas.component.html',
  styleUrls: ['./preview-encuestas.component.scss']
})
export class PreviewEncuestasComponent implements OnInit {
  url='companies/detail/:id/control-encuesta/';
  Autorizado=false;
  verificacion=false;
  preguntasAdicionalesFocus: backInter.getPreguntasAdiocnalesFocus;
  preguntasReactivosFocus: backInter.getPreguntasAdiocnalesFocus;
  preguntasTraduccionesAdicionalesFocus: backInter.mostrarTraducionesAdicionalesFocus;
  preguntasEncuestaAbiertas:any[]=[];
  preguntasEncuestaUnaOpcion:any[]=[];
  preguntasEncuestaMultipleOpcion:any[]=[];
  preguntasEncuestaAbiertasTradu:any[]=[];
  preguntasEncuestaUnaOpcionTradu:any[]=[];
  preguntasEncuestaMultipleOpcionTradu:any[]=[];
  //reactivosService
  preguntasReactivosPLantilla1:any[]=[];
  preguntasReactivosPLantilla2:any[]=[];
  idiomaNativo:string;
  banderaEncuestaFocus: backInter.actualizaBanderaFocus;

  idiomaAdicional:string;
  btnBanderaEncuesta:false;
  plantillaselect:string;
  plantillaselect2:string;

  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.BORRAR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.SI',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.NO',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_MOD_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_MOD_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_MOD_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_MOD_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_DEL_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_DEL_ERR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_DEL_OK',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_DEL_ERR',
    'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.RESTRICCION'
  ]


  constructor(
    private reactivosService: ReactivosService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private adicionalesAdminService: AdicionalesService,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
  ) {
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneAdicionales();
    this.obtieneTraduccionesAdicionales();
    this.getActualizaBanderaEvaluarEncuesta();
    this.getReactivosGuardados();
// console.log(this.idiomas);

  }

  obtieneAdicionales(){
    let preguntasAbiertas:any[]=[];
    let preguntasUnaOpcion:any[]=[];
    let preguntasMultipleOpcion:any[]=[];
    let data:any={empresaId:localStorage.getItem('empresaID'), seccion:7}
      this.adicionalesAdminService.getPreguntasAdicionalesFocusAdmin(data).subscribe( (data: backInter.getPreguntasAdiocnalesFocus) => {
      this.preguntasAdicionalesFocus = data;
       console.log(this.preguntasAdicionalesFocus);

      this.idiomaNativo=this.preguntasAdicionalesFocus.claveNativo;

      this.preguntasAdicionalesFocus.preguntas.forEach(element => {
        if (element.tipoRespuesta==2) {
          // console.log("si hay Abiertas");
          this.preguntasEncuestaAbiertas.push(element);
        }else if(element.tipoRespuesta==1){
        this.preguntasEncuestaUnaOpcion.push(element);
            console.log(this.preguntasEncuestaUnaOpcion);
      }else if(element.tipoRespuesta==6){
        this.preguntasEncuestaMultipleOpcion.push(element);
        console.log(this.preguntasEncuestaMultipleOpcion);

       }else{
         console.log("no hay nada ");

       }
});

// console.log(this.preguntasEncuestaAbiertas);
// console.log(this.preguntasEncuestaUnaOpcion);
// console.log(this.preguntasEncuestaMultipleOpcion);

});

}
obtieneTraduccionesAdicionales(){
  let datos:any= {empresaId:localStorage.getItem('empresaID'),seccion: 7};
  this.adicionalesAdminService.getTraduccionesAdicionalFocusAdmin(datos).subscribe( (data:backInter.mostrarTraducionesAdicionalesFocus) => {
    this.preguntasTraduccionesAdicionalesFocus = data;
    console.log(this.preguntasTraduccionesAdicionalesFocus);

    // console.log(this.preguntasTraduccionesAdicionalesFocus)
    // console.log("adicionales obtenidos:");    //
    //
    // console.log(this.preguntasEncuestaAbiertasTradu);
    // console.log(this.preguntasEncuestaUnaOpcionTradu);
    // console.log(this.preguntasEncuestaMultipleOpcionTradu);

  });

}
actualizaBanderaEvaluarEncuesta(validacion:number){
  let statusEncuesta:number;
  switch (validacion) {
    case 3:
     statusEncuesta=3;
      console.log("Autorizada");
      break;
    case 5:

    console.log("mando a corregir");
    statusEncuesta=5;

      break;

    default:
      break;
  }
  let datos={estatusVerificacion:statusEncuesta}

  this.adicionalesAdminService.actulizaBanderaEncuestaFocus(datos).subscribe( (data: any) => {
    console.log(data);
    this.getActualizaBanderaEvaluarEncuesta();
    });
}

// actualizaBanderaEvaluarEncuestaNoAprobada(){
//
//   let datos={estatusVerificacion:5}
//   this.adicionalesAdminService.actulizaBanderaEncuestaFocus(datos).subscribe( (data: any) => {
//     console.log(data);
//     this.getActualizaBanderaEvaluarEncuesta();
//     });
// }


 actualizarTextoPregunta(texto:string,idpreg:string){
   let adicionalFocus = {} as backInter.modificarAdicionalFocus;
   adicionalFocus.empresaId = localStorage.getItem('empresaID');
   adicionalFocus.preguntaId = idpreg;
   adicionalFocus.pregunta = texto;
   this.adicionalesAdminService.actualizaAdicionalFocus(adicionalFocus).subscribe( (data: backInter.modificarPreguntaAdicionalFocus ) => {
     console.log(data);
   if(data.message == "200"){
     let texto = 'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.PREG_MOD_OK';
       this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
       this.openSnackBar(''+texto,'');

     }
   });
 }

actualizarTextoOpcionPregunta(textoOpc:string,idpreg:string,idOpcion:string,){
  let opcion = {} as backInter.modificarOpcionAdicionalFocus;
  opcion.empresaId = localStorage.getItem('empresaID');
  opcion.preguntaId = idpreg;
  opcion.opcionId = idOpcion;
  opcion.respuesta = textoOpc;

      this.adicionalesAdminService.actualizaOpcionAdicionalFocus(opcion).subscribe( (data: any) => {
        console.log(data);
        if(data.message == "200"){
          let texto = 'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.MENSAJES.OPC_MOD_OK';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.openSnackBar(''+texto,'');
            console.log("se actualizo la opcion");

        }
      });
}

actualizaAdicionalTraduccionPregunta(idIdioma:string, idPregunta:string, traduccion:string){
  let traducciones:any={
    empresaId: localStorage.getItem('empresaID'),
    preguntaId: idPregunta,
    pregunta:traduccion,
    idiomaId: idIdioma

  }
      this.adicionalesAdminService.actualizaAdicionalTraduccionesFocus(traducciones).subscribe( (data:any) => {
        if(data.success){

          let texto = 'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_OK';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.openSnackBar(''+texto,'');
            console.log("se actualizo la traduccion de la pregunta");

        }
      });
    }

    actualizaTraduccionOpcionBD(idIdioma:string, idPreg:number, idOpc:number, opcTradu:string){
      let datosTradu: any = {
          "empresaId": localStorage.getItem('empresaID'),
          "preguntaId": idPreg,
          "respuesta": opcTradu,
          "orden": idOpc,
          "idiomaId": idIdioma
        };


      console.log("se actualizara una opcion. datos:");
      // console.log(opcion);

      this.adicionalesAdminService.actualizaAdicionalTraduccionesFocus(datosTradu).subscribe( (data: any) => {
        if(data.success){

                    let texto = 'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_OK';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  this.openSnackBar(''+texto,'');
                      console.log("se actualizo la traduccion de la pregunta");

        }


      });
    }

openSnackBar(message: string, action: string) {
  this._snackBar.open(message, action, {
    duration: 1000,
  });
}





getActualizaBanderaEvaluarEncuesta(){

  let datos={productoId:localStorage.getItem('productoID')};
  this.adicionalesAdminService.getActulizaBanderaEncuestaFocus(datos).subscribe( (data: backInter.actualizaBanderaFocus) => {
    console.log(data);

    this.banderaEncuestaFocus=data;
    });
}

getReactivosGuardados(){
  this.reactivosService.getGuardadosReactivosFocus(localStorage.getItem('encuestaID')).subscribe((respuesta:backInter.getPreguntasAdiocnalesFocus) => {
    console.log(respuesta);
    this.preguntasReactivosFocus=respuesta;
    this.preguntasReactivosFocus.preguntas.forEach(element => {
      if (element.plantillaId=="5ece9ebab473cb6d3e6d042a") {
        // console.log("si hay Abiertas");
        this.plantillaselect="Gobierno";
        this.preguntasReactivosPLantilla1.push(element);
      }else if(element.plantillaId=="5e166105d06d595eb04dca00"){
         this.plantillaselect2="Estandar";
      this.preguntasReactivosPLantilla2.push(element);
     }
});

console.log(this.preguntasReactivosPLantilla1);
console.log(this.preguntasReactivosPLantilla2);




});
}
}
